// @flow
import * as React from 'react';
import styled from 'styled-components';

type TProps = {
  children: string | React.Node,
  color?: string,
};

const StyledHeader2 = styled.h2`
  font-family: InterSemibold;
  line-height: 1.4;
  font-size: 16px;
  margin: 0;
  color: ${props => props.color || '#000'};
`;


export default function TextHeader2(props: TProps): React.Node {
  return (
    <StyledHeader2 color={props.color || null}>
      {props.children}
    </StyledHeader2>
  );
}
